import { render, staticRenderFns } from "./FoldersBar.vue?vue&type=template&id=4e087818&scoped=true&"
import script from "./FoldersBar.vue?vue&type=script&lang=js&"
export * from "./FoldersBar.vue?vue&type=script&lang=js&"
import style0 from "./FoldersBar.vue?vue&type=style&index=0&id=4e087818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e087818",
  null
  
)

export default component.exports